import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";

export default function AllPositionIndependent() {
  const params = useParams();
  const [webSitePublisherData, setWebSitePublisherData] = useState({});
  const [positions, setPositions] = useState([]);
  const sitePublisherID = params.id;

  useEffect(() => {
    getWebSitePublisherData();
  }, []);

  useEffect(() => {
    if (Object.keys(webSitePublisherData).length == 0) {
      return;
    }
    getAllPositionIndependent();
  }, [webSitePublisherData]);

  const getWebSitePublisherData = async () => {
    setWebSitePublisherData(
      await sendRequestGetWebSitePublisherData(sitePublisherID)
    );
  };

  const getAllPositionIndependent = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const positionIndependent = await sendRequestPositionIndependent(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!positionIndependent) {
      return;
    }
    setPositions(positionIndependent);
  };

  const sendRequestPositionIndependent = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/all-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const sendRequestGetWebSitePublisherData = async (sitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deletePosition = async (positionID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestDeletePosition = await sendRequestDeletePosition(
      positionID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestDeletePosition) {
      return;
    }
    await getAllPositionIndependent();
  };

  const sendRequestDeletePosition = async (positionID) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/independent-positions/" +
          positionID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const generateTagHtmlTablePositionIndependent = (positions) => {
    return positions.map((position, index) => {
      return (
        <tr key={position.pos_id}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(position.pos_id)}</td>
          <td>{helpersNumbers.toPersianNum(position.pos_priority)}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(position.pos_count)}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(position.pos_base_price)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(position.pos_price)
            )}
          </td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                position.pos_alternative_price
              )
            )}
          </td>
          <td style={{ letterSpacing: "2px" }}>
            {helpersNumbers.toPersianNum(position.pos_size)}
          </td>
          <td>
            <div dir="ltr" className="text-center">
              {position.pos_active ? (
                <span className="badge badge-success">فعال</span>
              ) : (
                <span className="badge badge-danger">غیرفعال</span>
              )}
            </div>
          </td>
          <td>{position.pos_tag_html_id}</td>
          <td>
            <span className="pl-2">
              <button
                className="btn btn-info"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(
                    `<div class="hil-banner-advertise" id="${position.pos_tag_html_id}"></div>`
                  );
                  alert("تگ html کپی شد.");
                }}
              >
                <i className="fas fa-copy"></i>
              </button>
            </span>
            <span className="pl-2">
              <Link
                to={`/manage/position/edit-independent/${position.pos_id}`}
                className="btn btn-success"
              >
                <i className="fa fa-edit"></i>
              </Link>
            </span>
            <span className="pl-2">
              <span
                className="btn btn-danger"
                onClick={() => deletePosition(position.pos_id)}
              >
                <i className="fa fa-trash"></i>
              </span>
            </span>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span>تمامی جایگاه های مستقل سایت </span>
                  <span className="pr-2 text-info">
                    {webSitePublisherData?.url?.replace("http://", "")}
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between pb-2">
                <div>
                  <div>
                    <Link
                      className="text-white"
                      to={`/manage/position/add-independent/${sitePublisherID}`}
                    >
                      <div className="btn btn-success">
                        <span className="pl-2">
                          <i
                            className="fa fa-plus text-white"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span>
                          <span className="text-white">
                            اضافه کردن جایگاه های مستقل
                          </span>
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>

                <div>
                  <Link to={`/manage/page/all/${sitePublisherID}`}>
                    <div className="btn btn-primary">
                      <span>
                        <span className="text-white">بازگشت</span>
                      </span>
                      <span className="pr-2">
                        <i className="fas fa-arrow-left" aria-hidden="true"></i>
                      </span>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="pb-2">
                <div className="table-responsive">
                  <table className="table table-hilite tbl-td-white-space">
                    <thead>
                      <tr>
                        <td>#</td>
                        <td>شماره</td>
                        <td>اولویت</td>
                        <td>تعداد بنر در جایگاه</td>
                        <td>مبلغ پایه</td>
                        <td>مبلغ</td>
                        <td>مبلغ بنر جایگزین</td>
                        <td>اندازه (ارتفاع - عرض)</td>
                        <td>وضعیت</td>
                        <td>id تگ جایگاه</td>
                        <td>عملیات</td>
                      </tr>
                    </thead>
                    <tbody>
                      {positions.length != 0 ? (
                        generateTagHtmlTablePositionIndependent(positions)
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <Link
                  className="text-white"
                  to={`/manage/position/add-image-independent/${sitePublisherID}`}
                >
                  <div className="btn btn-warning">
                    <span className="pl-2">
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span>
                      <span className="text-white">
                        اضافه کردن عکس جایگاه مستقل
                      </span>
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
